<template>
  <div class="">
    <FilePond
      name="file"
      ref="pond"
      :label-idle="labelIdle"
      :allow-multiple="true"
      :allow-revert="false"
      :accepted-file-types="acceptedFileTypes"
      :oninitfile="onInitFile"
      :onprocessfile="onProcessFile"
      :onprocessfiles="onProcessFiles"
      :instant-upload="true"
      :server="serverOptions"
    />
  </div>
</template>

<script>
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond/dist/filepond.min.css';

import { PROJECT_ASSETS } from '@/store/entities/schema_types';
import { getCookie } from '@/utils/helpers';

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  name: 'CreateMediaAssets',

  components: {
    FilePond,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
    acceptedFileTypes: {
      type: String,
      default: 'image/*, application/pdf, video/mp4',
    },
    onData: {
      type: Function,
      default: (formData) => formData,
    },
    onMediaAssetCreated: {
      type: Function,
      default: null,
    },
    onActive: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      labelIdle:
        "Drop files here or <span class='underline cursor-pointer'>Browse</span> to upload",
      active: false,
      serverOptions: {
        process: {
          url: `/api/v1/projects/${this.projectId}/project-assets/media`,
          method: 'POST',
          withCredentials: true,
          ondata: (formData) => this.normalizeProcessData(this.onData(formData)),
          headers: {
            Accept: 'application/json',
            'X-Xsrf-Token': getCookie('XSRF-TOKEN'),
          },
          onload: (response) => {
            const { data = null } = JSON.parse(response);
            this.onMediaUploaded(data);
          },
          onerror: null,
        },
        revert: null,
        restore: null,
        load: null,
        fetch: null,
      },
    };
  },

  methods: {
    normalizeProcessData(formData) {
      const fileParts = formData.getAll('file').filter((value) => value instanceof Blob);

      if (fileParts.length === 0) {
        return formData;
      }

      formData.delete('file');

      fileParts.forEach((file) => {
        formData.append('file', file, file.name || 'file');
      });

      return formData;
    },

    setActive(active) {
      this.active = active;
      if (typeof this.onActive === 'function') {
        this.onActive(active);
      }
    },
    onInitFile() {
      this.setActive(true);
    },
    onProcessFile(error, file) {
      setTimeout(() => {
        if (file.status === 5) {
          this.$refs.pond.removeFile(file.id);
        }

        if (this.$refs.pond.getFiles().length === 0) {
          this.setActive(false);
        }
      }, 1500);
    },
    onProcessFiles() {
      this.setActive(false);
    },
    async onMediaUploaded(data) {
      if (!data) {
        return;
      }

      try {
        const projectAssetId = await this.$store.dispatch('entities/persistEntities', {
          type: PROJECT_ASSETS,
          data,
        });

        await this.$store.commit({
          type: 'ui/projectProjectAssets/addProjectAssetIdToProject',
          projectId: this.projectId,
          projectAssetId,
        });

        if (typeof this.onMediaAssetCreated === 'function') {
          this.onMediaAssetCreated(projectAssetId, data);
        }
      } catch (error) {
        //
      }
    },
  },
};
</script>

<style>
.filepond--root {
  @apply mb-0;
}
</style>
